import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMyNotifications, useNotificationRead } from 'src/hooks/notification';
import { toSimpleDateString } from 'src/utils/format/date';
import moment from 'moment';
import s from './NotificationsMenu.styles';

const NotificationsMenu = props => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const ref = useRef(null);
  useEffect(() => {
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const { data: notificationsData, refetch } = useMyNotifications();
  const notifications = notificationsData?.myNotifications || [];
  const unreadNotifications = notifications.filter(c => !c.readedAt);

  const readNotification = useNotificationRead();
  const onRead = async (notification) => {
    await readNotification({ id: notification.id });
    refetch();
  };

  const prepareText = (text) => {
    const result = [];
    text.split('\n').forEach((line, index) => {
      result.push(<span key={index}>{line}</span>);
      result.push(<br key={`br${index}`} />);
    });

    return result;
  };

  return (
    <s.Menu>
      <s.Item onClick={() => setExpanded(true)} selected={expanded}>
        <s.Icon name="notifications-badge-white" />
        {(unreadNotifications.length > 0) && (
          <s.Badge>{unreadNotifications.length}</s.Badge>
        )}
        <s.Label>{t('MY_NOTIFICATIONS')}</s.Label>
      </s.Item>
      {expanded && (
        <s.PopupWrapper ref={ref} sideBarCollapsed={!props.expanded}>
          <s.PopupTitle>{t('MY_NOTIFICATIONS')}</s.PopupTitle>
          {notifications.map(notification => (
            <s.Notification key={notification.id}>
              <s.NotificationMark name={notification.type} />
              <s.NotificationText active={!notification.readedAt}>{prepareText(notification.text)}</s.NotificationText>
              {!notification.readedAt && (
                <s.NotificationReadBtn onClick={() => onRead(notification)}>{t('MARK_AS_READ')}</s.NotificationReadBtn>
              )}
              <s.NotificationPublishDate title={toSimpleDateString(notification.publishDate)}>
                {moment(notification.publishDate).fromNow()}
              </s.NotificationPublishDate>
            </s.Notification>
          ))}
        </s.PopupWrapper>
      )}
    </s.Menu>
  );
};

export default React.memo(NotificationsMenu);
